import { FC } from "react";
import { MainContentWrapper } from "../../layouts/base/MainContentWrapper";
import { MainContentHeader } from "../../layouts/base/MainContentHeader";
import { useTitlePage } from "../../hooks/use-title-page";
import { Box, Button, Link } from "@mui/material";

const title = "יצירת קשר";
const SupportPage: FC = () => {
  useTitlePage(title);
  return (
    <MainContentWrapper>
      <MainContentHeader title={title} />
      <Box>
        <Button
          component={Link}
          variant="contained"
          color="primary"
          href="mailto:support@echadapp.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ mt: 3 }}
        >
          ליצירת קשר עם התמיכה
        </Button>
      </Box>
    </MainContentWrapper>
  );
};

export default SupportPage;
